module.exports = __webpack_public_path__ + "static/img/login-one-bg.552e4883.png";